import { render, staticRenderFns } from "./jydz.vue?vue&type=template&id=99ca0d80&scoped=true&"
import script from "./jydz.vue?vue&type=script&lang=js&"
export * from "./jydz.vue?vue&type=script&lang=js&"
import style0 from "./jydz.vue?vue&type=style&index=0&id=99ca0d80&prod&scoped=true&lang=css&"
import style1 from "./jydz.vue?vue&type=style&index=1&id=99ca0d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ca0d80",
  null
  
)

export default component.exports